// Normalize legacy/malformed values: property prices below 1 Lakh are
// almost certainly entered in Lakhs (e.g. "1418" meaning ₹14.18 Cr).
// Convert those to raw rupees so display logic works uniformly.
export const normalizePriceValue = (value: number | null | undefined): number => {
  if (value == null || isNaN(value as number)) return 0;
  const v = Number(value);
  if (v > 0 && v < 100000) return v * 100000;
  return v;
};

export const formatINRShort = (rawValue: number): string => {
  const value = normalizePriceValue(rawValue);
  if (!value) return "₹0";
  if (value >= 10000000) return `₹${(value / 10000000).toFixed(2).replace(/\.?0+$/, '')}Cr`;
  if (value >= 100000) return `₹${(value / 100000).toFixed(2).replace(/\.?0+$/, '')}L`;
  return `₹${Math.round(value).toLocaleString('en-IN')}`;
};

export const formatPriceDisplay = (opts: {
  price_on_request?: boolean | null;
  price?: number | null;
  price_min?: number | null;
  price_max?: number | null;
}): string => {
  const { price_on_request, price, price_min, price_max } = opts;
  if (price_on_request) return "Price on Request";
  if (price_min != null && price_max != null) {
    return `${formatINRShort(price_min)} - ${formatINRShort(price_max)}`;
  }
  return formatINRShort(price ?? 0);
};
